export const membersQueryKeys = {
  GET_PROJECT_MEMBERS: 'get_teams_members',
  GET_PROJECT_TEAMS: 'get_teams_teams',
  GET_PROJECT_CONTACTS: 'get_teams_contacts'
}
